import axios from "axios";

const versionsUrl = "/api/v1/versions";

const versionsApi = {
  fetchVersions: payload => axios.get(versionsUrl, payload),
};

export default versionsApi;
